<template>
  <div>
    <transition name="slide-fade" appear>
      <b-row>
        <EncabezadoDocente/>
        <b-col cols="lg-4">
          <b-card overlay img-src="img/mis-tareas.jpg">
            <b-card-text>
              <b-button to="actividades/gestionactividades" variant="danger">Gestionar Actividades</b-button>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="lg-4">
          <b-card overlay img-src="img/mis-calificaciones.jpg">
            <b-card-text>
              <b-button to="actividades/revisartareas" variant="success">Revisar Tareas</b-button>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="lg-4">
          <b-card overlay img-src="img/mi-horario.jpg">
            <b-card-text>
              <b-button to="horarios/horarioclases" variant="primary">Horario de Clases</b-button>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="lg-12">
          <h2>Cartelera del Docente</h2>
          <div v-for="item in publicaciones" :key="item.id">
            <b-card class="text-center">
              <p class="text-right small float-right">Publicado el {{ item.fecha_publicacion.slice(0,10) }}</p>
              <p class="text-left small"><strong><i class="fab fa-galactic-republic"></i> {{ item.titulo }}</strong></p>
              <p class="text-left">{{ item.contenido}}</p>
            </b-card>
          </div>        
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
  import axios from "axios"
  import * as CONFIG from '@/assets/config.js'
  import EncabezadoDocente from '@/containers/EncabezadoDocente'

  export default {
    name: 'Dashboard',
    components: {
      EncabezadoDocente
    },
    data () {
      return {
        publicaciones: []
      }
    },
    methods: {
      async cargarPublicaciones() {
        await axios
        .get(CONFIG.ROOT_PATH + "publicaciones", { params: { bd: this.$store.state.bdColegio, destino: this.$store.state.idRolUsuario }})
        .then(response => {
        if (response.data.error){
            this.mensajeEmergente('danger','Mensaje',response.data.mensaje)
        } else{
            this.publicaciones = response.data.datos
        }
        })
        .catch(err => {
        if (err.message === "Network Error")
            this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
        else
            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
        });
      },
      validarSesion() {
        if (this.$store.state.idUsuario == '' || this.$store.state.idUsuario == null) {
          this.$router.push("/pages/sesionfinalizada")
        } else {
          this.cargarPublicaciones()
        }
      },
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false })
      }
    },
    beforeMount() {
      this.validarSesion()
    }
  }
</script>
